import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';
var css_248z = ".index-module_Button__Lw9Oe {\n  z-index: 4;\n  position: absolute;\n  color: inherit;\n  /* Placeholders */\n  width: 62px;\n  height: 62px;\n  /* Disabling default button CSS. */\n  padding: 0;\n  margin: 0;\n  outline: none;\n  background: transparent;\n  border: 0;\n}\n\n.index-module_Button__Lw9Oe svg path {\n  transition: d 200ms;\n}\n";
var AutoplayButtonModuleCss = {
  "Button": "index-module_Button__Lw9Oe"
};
styleInject(css_248z);
export { AutoplayButtonModuleCss as default };